export const calculateBounds = (
  bbox: {
    lng: number;
    lat: number;
  }[]
): [{ lng: number; lat: number }, { lng: number; lat: number }] | null => {
  if (!bbox?.length || bbox.length === 1) {
    return null;
  }

  let minLat = 90;
  let minLng = 180;
  let maxLat = -90;
  let maxLng = -180;

  bbox.forEach(({ lng, lat }) => {
    if (lng < minLng) {
      minLng = lng;
    }
    if (lng > maxLng) {
      maxLng = lng;
    }
    if (lat < minLat) {
      minLat = lat;
    }
    if (lat > maxLat) {
      maxLat = lat;
    }
  });
  return [
    { lng: minLng, lat: minLat },
    { lng: maxLng, lat: maxLat }
  ];
};
